export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function extractInlineText(value: unknown): string[] {
  if (Array.isArray(value)) return value.flatMap(extractInlineText);
  if (!isRecord(value)) return [];
  const text = value.text;
  if (typeof text === "string") return [text];
  const children = value.children;
  return children ? extractInlineText(children) : [];
}

export function toAddressLines(value: unknown): string[] {
  if (!Array.isArray(value)) return [];
  const lines: string[] = [];
  for (const node of value) {
    if (isRecord(node) && node.type === "paragraph" && Array.isArray(node.children)) {
      const line = extractInlineText(node.children).join("").trim();
      if (line) lines.push(line);
      continue;
    }
    const fallbackLine = extractInlineText(node).join("").trim();
    if (fallbackLine) lines.push(fallbackLine);
  }
  return lines;
}
